module.exports = __webpack_public_path__ + "img/chat-v2.eb031048.webp";